import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: '#2DD4A0',
        secondary: '#34D399',
        accent: '#2DD4A0',
        background: '#1E2230',
        surface: '#262B3A',
        error: '#EF5350',
        warning: '#FFA726',
        info: '#42A5F5',
        success: '#2DD4A0',
      },
    },
    options: {
      customProperties: true,
    },
  },
  icons: {
    iconfont: 'mdi',
  },
})
